// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module_scrollbar_container_pjm33 {
}

.styles-module_scrollbar_container_pjm33::-webkit-scrollbar {
  width: 12px;
}

.styles-module_scrollbar_container_pjm33::-webkit-scrollbar-track-piece:end,
.styles-module_scrollbar_container_pjm33::-webkit-scrollbar-track-piece:start,
.styles-module_scrollbar_container_pjm33::-webkit-scrollbar-corner {
  background: var(--primary-bg-color);
}

.styles-module_scrollbar_container_pjm33::-webkit-scrollbar-thumb {
  background-color: var(--bp-light-gray2);
  border-radius: 10px;
  border: 2px solid var(--primary-bg-color);
}

.styles-module_scrollbar_container_pjm33::-webkit-scrollbar-thumb:hover {
  /* background-color: rgb(190 30 12 / 70%); */
}

.styles-module_scrollbar_container_pjm33::-webkit-scrollbar-track {
  margin-bottom: var(--footer-height);
}

.styles-module_no_content_Z0Sod {
  font-style: italic;
  color: var(--bp-gray3);
}

.styles-module_disabled_i0m6m {
  opacity: 0.7 !important;
  pointer-events: none;
}

.styles-module_inactive_uad8e {
  color: var(--muted-text);
  font-style: italic;
}

.styles-module_bos_popover_XcWuX {
  background-color: white;
  padding: 20px;
}

/*Buttons*/
.styles-module_bos_button_transition_yCfQ4,
.styles-module_bos_link_transition_BZuEt {
  transition: all 0.25s ease-in-out !important;
}

.styles-module_bos_button_transition_yCfQ4:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2),
    0 4px 12px 4px rgba(84, 117, 145, 0.2) !important;
}

.styles-module_bos_link_transition_BZuEt:hover {
  transform: translateY(-2px);
  /* box-shadow: 0px 10px 10px 0px rgba(84, 117, 145, 0.2); */
}

.styles-module_bos_button_md7Pb {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  font-size: 14px;
  justify-content: center;
  padding: 10px 20px;
  text-align: left;
  vertical-align: middle;
  min-height: 30px;
  min-width: 30px;
  gap: 4px;
  box-shadow: inset 0 0 0 2px rgb(0 0 0 / 20%);
}

.styles-module_primary_button_zUhDq {
}

.styles-module_primary_button_zUhDq,
.styles-module_primary_button_zUhDq span {
  color: var(--primary-bos-color) !important;
}

.styles-module_primary_button_zUhDq:not(:disabled):hover,
.styles-module_primary_button_zUhDq:not(:disabled):hover span {
  color: var(--primary-button-hover-color) !important;
  background: none !important;
}

.styles-module_primary_button_light_TOYne {
  opacity: 0.6;
}

.styles-module_primary_button_light_TOYne:hover {
  opacity: 1;
}

.styles-module_primary_button_minimal_JaDZs {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.styles-module_primary_button_minimal_JaDZs:not(:disabled):hover {
  box-shadow: none !important;
}

.styles-module_primary_button_outlined_gUTnU {
  box-shadow: none !important;
  border: 1px solid var(--primary-bos-color) !important;
  background-color: white !important;
}

.styles-module_secondary_button_qqI7z {
}

.styles-module_secondary_button_qqI7z,
.styles-module_secondary_button_qqI7z span {
  color: var(--secondary-bos-color) !important;
}

.styles-module_secondary_button_qqI7z:hover,
.styles-module_secondary_button_qqI7z:hover span {
  color: var(--uu-footer-links-hover) !important;
}

.styles-module_secondary_outlined_y0wC5 {
  border: 1px solid var(--cp3-purple-5) !important;
}

.styles-module_primary_button_bold_pZAFo {
  background-color: var(--primary-bos-color) !important;
  color: white !important;
}

.styles-module_primary_button_bold_pZAFo span,
.styles-module_primary_button_bold_pZAFo svg {
  color: white;
}

.styles-module_primary_button_bold_pZAFo:hover {
  background-color: var(--primary-button-hover-color) !important;
  color: white !important;
  text-decoration: none;
}

.styles-module_primary_button_bold_pZAFo:hover span {
  color: white;
}

.styles-module_bos_button_large_UxhpK {
  min-height: 40px;
  min-width: 40px;
  font-size: 16px;
  padding: 5px 15px;
}

.styles-module_uu_button_nBNZ1 {
  color: var(--uu-utah-red) !important;
}

.styles-module_uu_button_nBNZ1:hover {
  color: var(--uu-utah-red-hover) !important;
}

.styles-module_uu_button_bold_KqSp6 {
  background-color: var(--uu-utah-red) !important;
}

.styles-module_uu_button_bold_KqSp6:hover {
  background-color: var(--uu-utah-red-hover) !important;
}

.styles-module_uu_button_white_NioKg {
  background-color: white;
  color: var(--uu-utah-red);
  border: 2px solid var(--uu-utah-red);
  display: inline-block;
  text-decoration: none;
  text-align: center;
  text-transform: uppercase;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  padding: 8px 20px;
}

.styles-module_uu_button_white_NioKg:hover {
  background-color: var(--uu-utah-red);
  color: white;
  text-decoration: none;
}

.styles-module_uu_link_MUivb {
  color: var(--uu-utah-red);
}

.styles-module_uu_link_MUivb:hover {
  color: var(--uu-utah-red-hover);
}

.styles-module_update_status_button_pklIs {
  color: white !important;
  height: 100%;
}

.styles-module_update_status_button_icon_RNh5i {
  margin: 0 !important;
}

.styles-module_confirm_purchase_button_MIaeV {
  background-color: var(--status_transaction_created) !important;
}

.styles-module_confirm_purchase_button_icon_X_WS8 {
  margin: 0 !important;
}

.styles-module_floating_item_kO2nJ {
  box-shadow: 0 12px 10px -10px rgba(0, 0, 0, 0.4) !important;
  z-index: 2;
}

.styles-module_floating_item_kO2nJ:hover {
  box-shadow: 0 18px 10px -10px rgba(0, 0, 0, 0.4) !important;
  transform: translate(0px, -4px);
}

.styles-module_not_floating_O4tuk {
  box-shadow: none !important;
  z-index: 1;
}

/*******************************/
/* Navigation Tab-like Buttons */
/*******************************/
.styles-module_nav_button_XGkDt {
  height: 100%;
  font-size: 13pt;
  font-weight: 400;
  margin-left: 8px;
  margin-right: 8px;
  padding: 8px 12px;
  display: inline-flex;
  flex-direction: row;
  align-items: end;
  color: var(--site-icon-color);
  border-bottom: 3px solid transparent;
  transition: border-color 0.5s ease, background-color 0.5s ease;
  font-family: Montserrat, sans-serif;
  box-shadow: none;
}

.styles-module_nav_button_XGkDt:last-child {
  margin-right: 10px !important;
}

.styles-module_nav_button_XGkDt:hover {
  background-color: var(--uu-light-gray-bg);
  color: var(--primary-hover-color);
  font-weight: 500;
}

a:is(.styles-module_nav_button_XGkDt) {
  text-decoration: none;
}

a:hover:is(.styles-module_nav_button_XGkDt) {
  text-decoration: none;
}

a:is(.styles-module_nav_button_XGkDt):not(.styles-module_nav_button_dark_Llyp3) {
  color: var(--site-icon-color);
}

a:hover:is(.styles-module_nav_button_XGkDt):not(.styles-module_nav_button_dark_Llyp3) {
  color: var(--primary-hover-color);
}

.styles-module_nav_button_selected_fdr1N {
  font-weight: 500;
  color: var(--site-icon-color);
  border-color: var(--site-icon-color) !important;
}

.styles-module_nav_button_selected_fdr1N:hover {
  border-color: var(--primary-hover-color) !important;
}

/* Dark Scheme */
.styles-module_nav_button_dark_Llyp3 {
  color: white !important;
  font-weight: 500;
}

.styles-module_nav_button_dark_Llyp3:hover {
  background-color: var(--site-icon-color) !important;
  color: white !important;
}

a:is(.styles-module_nav_button_dark_Llyp3) {
  color: white !important;
}

a:hover:is(.styles-module_nav_button_dark_Llyp3) {
  color: white !important;
}

.styles-module_nav_button_selected_dark_jCmFo {
  border-color: white !important;
}

.styles-module_nav_button_selected_dark_jCmFo:hover {
  border-color: white !important;
}

/*******************************/
/*******************************/

/* Links */
.styles-module_bos_link_o7I67 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.styles-module_bos_footer_link_UcBvr {
  text-transform: uppercase;
  color: var(--uu-footer-links-bottom);
}

.styles-module_bos_link_o7I67:hover {
  text-decoration: none;
}

.styles-module_bos_footer_link_UcBvr:hover {
  text-decoration: none;
  color: var(--uu-footer-links-hover-bottom);
}

.styles-module_bos_link_o7I67 span {
  font-size: large;
  margin-bottom: 3px;
}

.styles-module_bos_external_link_lRBhb {
  text-decoration: underline;
  font-size: medium;
}

.styles-module_bos_external_link_lRBhb:hover {
  text-decoration: underline;
}

.styles-module_font_medium_KIVsg span {
  font-size: medium;
}

/***************/
/*Editing/Input*/
/***************/
.styles-module_bos_input_CPZsE {
  min-width: 100px;
}

.styles-module_bos_numerical_input_cw7UM {
  min-width: 80px;
}

.styles-module_bos_input_CPZsE > div {
  flex-shrink: 1;
}

.styles-module_bos_money_input_vCuIM {
}

.styles-module_bos_money_input_with_clear_fVW8x {
}

.styles-module_bos_money_input_vCuIM input {
  text-align: right;
  padding-right: 6px !important;
}

.styles-module_input_label_HHSxu {
  font-weight: 500;
  margin-bottom: 0 !important;
  margin-right: 10px;
  text-align: center;
}

.styles-module_required_input_Hex3f {
}

.styles-module_required_SMaCK {
  color: var(--required-input);
}

.styles-module_required_input_Hex3f input::placeholder {
  color: var(--required-input);
}

/*Filter/Dropdown components*/
.styles-module_filter_label_input_box_Nw7kQ {
  line-height: 1.15;
  flex-grow: 1;
}

.styles-module_filter_label_header_box_I7S9b {
  max-width: calc(100% - 6px);
}

.styles-module_filter_label_input_box_Nw7kQ > span {
  position: relative;
  margin: 0 2px;
}

.styles-module_filter_label_header_box_I7S9b:hover > span:first-child,
.styles-module_filter_label_header_box_I7S9b:hover *:first-child:not(button) span {
  z-index: 10;
  overflow-x: visible;
  background-color: #e5e8eb;
}

.styles-module_filter_switch_vadl5 {
  margin: 2px !important;
}

.styles-module_filter_selection_menu_q1RYC {
  max-height: 302px;
  overflow-x: hidden;
}

.styles-module_filter_selection_menu_q1RYC ul {
  padding: 0;
  min-width: unset;
}

.styles-module_filter_selection_menu_q1RYC > ul > li > a > div {
  padding-right: 22px;
}

/********/
/*Tables*/
/********/
.styles-module_editable_table_NZjWC {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  cursor: default;
}

.styles-module_editable_table_NZjWC td {
  padding: 8px 12px;
  vertical-align: middle;
}

.styles-module_editable_table_compact_s5v_j {
}

.styles-module_editable_table_compact_s5v_j td {
  padding: 4px 10px;
}

.styles-module_table_header_cell_VmzdZ {
  text-align: center;
  vertical-align: bottom;
  font-weight: 600;
  white-space: nowrap;
}

.styles-module_editable_table_edit_mode_SYjF4 td:not(.styles-module_table_header_cell_VmzdZ) {
  padding: 4px 2px;
}

.styles-module_editable_table_edit_mode_SYjF4 td:first-child {
  padding-left: 8px;
}

.styles-module_editable_table_edit_mode_SYjF4 td:last-child {
  padding-right: 8px;
}

.styles-module_money_cell_gQh_8 {
  text-align: right;
}

.styles-module_table_total_cell_PFqMK {
  font-size: larger;
  text-align: right;
  font-weight: 500;
}

.styles-module_status_tag_MrWSz {
  font-family: 'Montserrat', sans-serif;
  line-height: 1.1;
  width: 100%;
  text-align: center !important;
  white-space: normal;
  border-radius: 6px !important;
}

.styles-module_status_tag_MrWSz span {
  color: white;
  font-size: 13px;
  font-weight: 500;

  -webkit-line-clamp: 2;
  overflow-y: clip;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
}

.styles-module_status_tag_MrWSz span > svg {
  color: white;
}

/****************/
/*General Layout*/
/****************/
.styles-module_panel_content_box_WbDO7 {
  display: flex;
  gap: 10px;
}

.styles-module_panel_content_box_vertical_QvKJk {
  flex-direction: column;
}

/*Flex box for displaying detail panels (Request/Transaction details, etc)*/
.styles-module_panel_flex_box_nLgOV {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  max-width: 100%;
}

.styles-module_panel_flex_box_nLgOV > * {
  flex-grow: 1;
  flex-shrink: 2;
  flex-basis: 22%;
  max-width: 100%;
}

.styles-module_half_panel_H4pyA {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 48%;
}

.styles-module_semi_wide_panel_PDRLF {
  flex-grow: 2;
  flex-shrink: 1;
  flex-basis: 60%;
}

.styles-module_wide_panel_ta9JZ {
  flex-grow: 3;
  flex-shrink: 0;
  flex-basis: 60%;
}

.styles-module_full_width_panel_h51J9 {
  flex-grow: 3;
  flex-shrink: 0;
  flex-basis: 100%;
  max-width: 100%;
}

.styles-module_bos_label_IUS6Z {
  font-weight: 600;
  margin-bottom: 0 !important;
}

.styles-module_bos_sub_label_eXtbJ {
  font-weight: 400;
  font-style: italic;
  margin-bottom: 2px !important;
}

.styles-module_light_border_WVXA4 {
  border: 1px solid var(--bp-light-gray1);
}

.styles-module_light_border_top_r4cHN {
  border-top: 1px solid var(--bp-light-gray1);
}
`, "",{"version":3,"sources":["webpack://./src/client/styles/styles.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,UAAU;AACV;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B;qDACmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;AAEA;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EAEE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,uBAAuB;EACvB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAEE,2BAA2B;EAC3B,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;AAEA;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EAEE,gDAAgD;AAClD;;AAEA;EAEE,qDAAqD;EACrD,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,8DAA8D;EAC9D,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EAEE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EAEE,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE,2DAA2D;EAC3D,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,gCAAgC;AAChC,gCAAgC;AAChC,gCAAgC;AAChC;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,8DAA8D;EAC9D,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EAEE,gBAAgB;EAChB,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,gBAAgB;AAChB;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC,gCAAgC;;AAEhC,UAAU;AACV;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAEE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB,gBAAgB;AAChB,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;AAEA;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT,SAAS;AACT,SAAS;AACT;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;AAEA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;;EAEhB,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EAEE,sBAAsB;AACxB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":[".scrollbar_container {\n}\n\n.scrollbar_container::-webkit-scrollbar {\n  width: 12px;\n}\n\n.scrollbar_container::-webkit-scrollbar-track-piece:end,\n.scrollbar_container::-webkit-scrollbar-track-piece:start,\n.scrollbar_container::-webkit-scrollbar-corner {\n  background: var(--primary-bg-color);\n}\n\n.scrollbar_container::-webkit-scrollbar-thumb {\n  background-color: var(--bp-light-gray2);\n  border-radius: 10px;\n  border: 2px solid var(--primary-bg-color);\n}\n\n.scrollbar_container::-webkit-scrollbar-thumb:hover {\n  /* background-color: rgb(190 30 12 / 70%); */\n}\n\n.scrollbar_container::-webkit-scrollbar-track {\n  margin-bottom: var(--footer-height);\n}\n\n.no_content {\n  font-style: italic;\n  color: var(--bp-gray3);\n}\n\n.disabled {\n  opacity: 0.7 !important;\n  pointer-events: none;\n}\n\n.inactive {\n  color: var(--muted-text);\n  font-style: italic;\n}\n\n.bos_popover {\n  background-color: white;\n  padding: 20px;\n}\n\n/*Buttons*/\n.bos_button_transition,\n.bos_link_transition {\n  transition: all 0.25s ease-in-out !important;\n}\n\n.bos_button_transition:not(:disabled):hover {\n  transform: translateY(-2px);\n  box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2),\n    0 4px 12px 4px rgba(84, 117, 145, 0.2) !important;\n}\n\n.bos_link_transition:hover {\n  transform: translateY(-2px);\n  /* box-shadow: 0px 10px 10px 0px rgba(84, 117, 145, 0.2); */\n}\n\n.bos_button {\n  composes: bos_button_transition;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  border: none;\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 14px;\n  justify-content: center;\n  padding: 10px 20px;\n  text-align: left;\n  vertical-align: middle;\n  min-height: 30px;\n  min-width: 30px;\n  gap: 4px;\n  box-shadow: inset 0 0 0 2px rgb(0 0 0 / 20%);\n}\n\n.primary_button {\n  composes: bos_button_transition;\n}\n\n.primary_button,\n.primary_button span {\n  color: var(--primary-bos-color) !important;\n}\n\n.primary_button:not(:disabled):hover,\n.primary_button:not(:disabled):hover span {\n  color: var(--primary-button-hover-color) !important;\n  background: none !important;\n}\n\n.primary_button_light {\n  composes: primary_button;\n  opacity: 0.6;\n}\n\n.primary_button_light:hover {\n  opacity: 1;\n}\n\n.primary_button_minimal {\n  composes: primary_button;\n  border: none !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.primary_button_minimal:not(:disabled):hover {\n  box-shadow: none !important;\n}\n\n.primary_button_outlined {\n  composes: primary_button;\n  box-shadow: none !important;\n  border: 1px solid var(--primary-bos-color) !important;\n  background-color: white !important;\n}\n\n.secondary_button {\n  composes: primary_button_minimal;\n}\n\n.secondary_button,\n.secondary_button span {\n  color: var(--secondary-bos-color) !important;\n}\n\n.secondary_button:hover,\n.secondary_button:hover span {\n  color: var(--uu-footer-links-hover) !important;\n}\n\n.secondary_outlined {\n  composes: bos_button_transition;\n  border: 1px solid var(--cp3-purple-5) !important;\n}\n\n.primary_button_bold {\n  composes: bos_button_transition;\n  background-color: var(--primary-bos-color) !important;\n  color: white !important;\n}\n\n.primary_button_bold span,\n.primary_button_bold svg {\n  color: white;\n}\n\n.primary_button_bold:hover {\n  background-color: var(--primary-button-hover-color) !important;\n  color: white !important;\n  text-decoration: none;\n}\n\n.primary_button_bold:hover span {\n  color: white;\n}\n\n.bos_button_large {\n  min-height: 40px;\n  min-width: 40px;\n  font-size: 16px;\n  padding: 5px 15px;\n}\n\n.uu_button {\n  composes: bos_button_transition;\n  color: var(--uu-utah-red) !important;\n}\n\n.uu_button:hover {\n  color: var(--uu-utah-red-hover) !important;\n}\n\n.uu_button_bold {\n  composes: primary_button_bold;\n  background-color: var(--uu-utah-red) !important;\n}\n\n.uu_button_bold:hover {\n  background-color: var(--uu-utah-red-hover) !important;\n}\n\n.uu_button_white {\n  composes: bos_button_transition;\n  background-color: white;\n  color: var(--uu-utah-red);\n  border: 2px solid var(--uu-utah-red);\n  display: inline-block;\n  text-decoration: none;\n  text-align: center;\n  text-transform: uppercase;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 4px;\n  padding: 8px 20px;\n}\n\n.uu_button_white:hover {\n  background-color: var(--uu-utah-red);\n  color: white;\n  text-decoration: none;\n}\n\n.uu_link {\n  composes: bos_link_transition;\n  color: var(--uu-utah-red);\n}\n\n.uu_link:hover {\n  color: var(--uu-utah-red-hover);\n}\n\n.update_status_button {\n  color: white !important;\n  height: 100%;\n}\n\n.update_status_button_icon {\n  composes: update_status_button;\n  margin: 0 !important;\n}\n\n.confirm_purchase_button {\n  composes: update_status_button;\n  background-color: var(--status_transaction_created) !important;\n}\n\n.confirm_purchase_button_icon {\n  composes: update_status_button;\n  margin: 0 !important;\n}\n\n.floating_item {\n  box-shadow: 0 12px 10px -10px rgba(0, 0, 0, 0.4) !important;\n  z-index: 2;\n}\n\n.floating_item:hover {\n  box-shadow: 0 18px 10px -10px rgba(0, 0, 0, 0.4) !important;\n  transform: translate(0px, -4px);\n}\n\n.not_floating {\n  box-shadow: none !important;\n  z-index: 1;\n}\n\n/*******************************/\n/* Navigation Tab-like Buttons */\n/*******************************/\n.nav_button {\n  height: 100%;\n  font-size: 13pt;\n  font-weight: 400;\n  margin-left: 8px;\n  margin-right: 8px;\n  padding: 8px 12px;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: end;\n  color: var(--site-icon-color);\n  border-bottom: 3px solid transparent;\n  transition: border-color 0.5s ease, background-color 0.5s ease;\n  font-family: Montserrat, sans-serif;\n  box-shadow: none;\n}\n\n.nav_button:last-child {\n  margin-right: 10px !important;\n}\n\n.nav_button:hover {\n  background-color: var(--uu-light-gray-bg);\n  color: var(--primary-hover-color);\n  font-weight: 500;\n}\n\na:is(.nav_button) {\n  text-decoration: none;\n}\n\na:hover:is(.nav_button) {\n  text-decoration: none;\n}\n\na:is(.nav_button):not(.nav_button_dark) {\n  color: var(--site-icon-color);\n}\n\na:hover:is(.nav_button):not(.nav_button_dark) {\n  color: var(--primary-hover-color);\n}\n\n.nav_button_selected {\n  composes: nav_button;\n  font-weight: 500;\n  color: var(--site-icon-color);\n  border-color: var(--site-icon-color) !important;\n}\n\n.nav_button_selected:hover {\n  border-color: var(--primary-hover-color) !important;\n}\n\n/* Dark Scheme */\n.nav_button_dark {\n  composes: nav_button;\n  color: white !important;\n  font-weight: 500;\n}\n\n.nav_button_dark:hover {\n  background-color: var(--site-icon-color) !important;\n  color: white !important;\n}\n\na:is(.nav_button_dark) {\n  color: white !important;\n}\n\na:hover:is(.nav_button_dark) {\n  color: white !important;\n}\n\n.nav_button_selected_dark {\n  composes: nav_button_dark;\n  border-color: white !important;\n}\n\n.nav_button_selected_dark:hover {\n  border-color: white !important;\n}\n\n/*******************************/\n/*******************************/\n\n/* Links */\n.bos_link {\n  composes: uu_link;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bos_footer_link {\n  composes: bos_link;\n  text-transform: uppercase;\n  color: var(--uu-footer-links-bottom);\n}\n\n.bos_link:hover {\n  text-decoration: none;\n}\n\n.bos_footer_link:hover {\n  text-decoration: none;\n  color: var(--uu-footer-links-hover-bottom);\n}\n\n.bos_link span {\n  font-size: large;\n  margin-bottom: 3px;\n}\n\n.bos_external_link {\n  composes: bos_link;\n  text-decoration: underline;\n  font-size: medium;\n}\n\n.bos_external_link:hover {\n  text-decoration: underline;\n}\n\n.font_medium span {\n  font-size: medium;\n}\n\n/***************/\n/*Editing/Input*/\n/***************/\n.bos_input {\n  min-width: 100px;\n}\n\n.bos_numerical_input {\n  composes: bos_input;\n  min-width: 80px;\n}\n\n.bos_input > div {\n  flex-shrink: 1;\n}\n\n.bos_money_input {\n  composes: bos_input;\n}\n\n.bos_money_input_with_clear {\n  composes: bos_input;\n}\n\n.bos_money_input input {\n  text-align: right;\n  padding-right: 6px !important;\n}\n\n.input_label {\n  font-weight: 500;\n  margin-bottom: 0 !important;\n  margin-right: 10px;\n  text-align: center;\n}\n\n.required_input {\n  composes: bos_input;\n}\n\n.required {\n  color: var(--required-input);\n}\n\n.required_input input::placeholder {\n  color: var(--required-input);\n}\n\n/*Filter/Dropdown components*/\n.filter_label_input_box {\n  line-height: 1.15;\n  flex-grow: 1;\n}\n\n.filter_label_header_box {\n  composes: filter_label_input_box;\n  max-width: calc(100% - 6px);\n}\n\n.filter_label_input_box > span {\n  position: relative;\n  margin: 0 2px;\n}\n\n.filter_label_header_box:hover > span:first-child,\n.filter_label_header_box:hover *:first-child:not(button) span {\n  z-index: 10;\n  overflow-x: visible;\n  background-color: #e5e8eb;\n}\n\n.filter_switch {\n  margin: 2px !important;\n}\n\n.filter_selection_menu {\n  max-height: 302px;\n  overflow-x: hidden;\n}\n\n.filter_selection_menu ul {\n  padding: 0;\n  min-width: unset;\n}\n\n.filter_selection_menu > ul > li > a > div {\n  padding-right: 22px;\n}\n\n/********/\n/*Tables*/\n/********/\n.editable_table {\n  width: 100%;\n  max-width: 100%;\n  border-collapse: collapse;\n  cursor: default;\n}\n\n.editable_table td {\n  padding: 8px 12px;\n  vertical-align: middle;\n}\n\n.editable_table_compact {\n  composes: editable_table;\n}\n\n.editable_table_compact td {\n  padding: 4px 10px;\n}\n\n.table_header_cell {\n  text-align: center;\n  vertical-align: bottom;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.editable_table_edit_mode td:not(.table_header_cell) {\n  padding: 4px 2px;\n}\n\n.editable_table_edit_mode td:first-child {\n  padding-left: 8px;\n}\n\n.editable_table_edit_mode td:last-child {\n  padding-right: 8px;\n}\n\n.money_cell {\n  text-align: right;\n}\n\n.table_total_cell {\n  font-size: larger;\n  text-align: right;\n  font-weight: 500;\n}\n\n.status_tag {\n  font-family: 'Montserrat', sans-serif;\n  line-height: 1.1;\n  width: 100%;\n  text-align: center !important;\n  white-space: normal;\n  border-radius: 6px !important;\n}\n\n.status_tag span {\n  color: white;\n  font-size: 13px;\n  font-weight: 500;\n\n  -webkit-line-clamp: 2;\n  overflow-y: clip;\n  display: -webkit-box !important;\n  -webkit-box-orient: vertical;\n}\n\n.status_tag span > svg {\n  color: white;\n}\n\n/****************/\n/*General Layout*/\n/****************/\n.panel_content_box {\n  display: flex;\n  gap: 10px;\n}\n\n.panel_content_box_vertical {\n  composes: panel_content_box;\n  flex-direction: column;\n}\n\n/*Flex box for displaying detail panels (Request/Transaction details, etc)*/\n.panel_flex_box {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  max-width: 100%;\n}\n\n.panel_flex_box > * {\n  flex-grow: 1;\n  flex-shrink: 2;\n  flex-basis: 22%;\n  max-width: 100%;\n}\n\n.half_panel {\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 48%;\n}\n\n.semi_wide_panel {\n  flex-grow: 2;\n  flex-shrink: 1;\n  flex-basis: 60%;\n}\n\n.wide_panel {\n  flex-grow: 3;\n  flex-shrink: 0;\n  flex-basis: 60%;\n}\n\n.full_width_panel {\n  flex-grow: 3;\n  flex-shrink: 0;\n  flex-basis: 100%;\n  max-width: 100%;\n}\n\n.bos_label {\n  font-weight: 600;\n  margin-bottom: 0 !important;\n}\n\n.bos_sub_label {\n  composes: secondary_color from 'Styles/colors.module.css';\n  font-weight: 400;\n  font-style: italic;\n  margin-bottom: 2px !important;\n}\n\n.light_border {\n  border: 1px solid var(--bp-light-gray1);\n}\n\n.light_border_top {\n  border-top: 1px solid var(--bp-light-gray1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbar_container": `styles-module_scrollbar_container_pjm33`,
	"no_content": `styles-module_no_content_Z0Sod`,
	"disabled": `styles-module_disabled_i0m6m`,
	"inactive": `styles-module_inactive_uad8e`,
	"bos_popover": `styles-module_bos_popover_XcWuX`,
	"bos_button_transition": `styles-module_bos_button_transition_yCfQ4`,
	"bos_link_transition": `styles-module_bos_link_transition_BZuEt`,
	"bos_button": `styles-module_bos_button_md7Pb styles-module_bos_button_transition_yCfQ4`,
	"primary_button": `styles-module_primary_button_zUhDq styles-module_bos_button_transition_yCfQ4`,
	"primary_button_light": `styles-module_primary_button_light_TOYne styles-module_primary_button_zUhDq styles-module_bos_button_transition_yCfQ4`,
	"primary_button_minimal": `styles-module_primary_button_minimal_JaDZs styles-module_primary_button_zUhDq styles-module_bos_button_transition_yCfQ4`,
	"primary_button_outlined": `styles-module_primary_button_outlined_gUTnU styles-module_primary_button_zUhDq styles-module_bos_button_transition_yCfQ4`,
	"secondary_button": `styles-module_secondary_button_qqI7z styles-module_primary_button_minimal_JaDZs styles-module_primary_button_zUhDq styles-module_bos_button_transition_yCfQ4`,
	"secondary_outlined": `styles-module_secondary_outlined_y0wC5 styles-module_bos_button_transition_yCfQ4`,
	"primary_button_bold": `styles-module_primary_button_bold_pZAFo styles-module_bos_button_transition_yCfQ4`,
	"bos_button_large": `styles-module_bos_button_large_UxhpK`,
	"uu_button": `styles-module_uu_button_nBNZ1 styles-module_bos_button_transition_yCfQ4`,
	"uu_button_bold": `styles-module_uu_button_bold_KqSp6 styles-module_primary_button_bold_pZAFo styles-module_bos_button_transition_yCfQ4`,
	"uu_button_white": `styles-module_uu_button_white_NioKg styles-module_bos_button_transition_yCfQ4`,
	"uu_link": `styles-module_uu_link_MUivb styles-module_bos_link_transition_BZuEt`,
	"update_status_button": `styles-module_update_status_button_pklIs`,
	"update_status_button_icon": `styles-module_update_status_button_icon_RNh5i styles-module_update_status_button_pklIs`,
	"confirm_purchase_button": `styles-module_confirm_purchase_button_MIaeV styles-module_update_status_button_pklIs`,
	"confirm_purchase_button_icon": `styles-module_confirm_purchase_button_icon_X_WS8 styles-module_update_status_button_pklIs`,
	"floating_item": `styles-module_floating_item_kO2nJ`,
	"not_floating": `styles-module_not_floating_O4tuk`,
	"nav_button": `styles-module_nav_button_XGkDt`,
	"nav_button_dark": `styles-module_nav_button_dark_Llyp3 styles-module_nav_button_XGkDt`,
	"nav_button_selected": `styles-module_nav_button_selected_fdr1N styles-module_nav_button_XGkDt`,
	"nav_button_selected_dark": `styles-module_nav_button_selected_dark_jCmFo styles-module_nav_button_dark_Llyp3 styles-module_nav_button_XGkDt`,
	"bos_link": `styles-module_bos_link_o7I67 styles-module_uu_link_MUivb styles-module_bos_link_transition_BZuEt`,
	"bos_footer_link": `styles-module_bos_footer_link_UcBvr styles-module_bos_link_o7I67 styles-module_uu_link_MUivb styles-module_bos_link_transition_BZuEt`,
	"bos_external_link": `styles-module_bos_external_link_lRBhb styles-module_bos_link_o7I67 styles-module_uu_link_MUivb styles-module_bos_link_transition_BZuEt`,
	"font_medium": `styles-module_font_medium_KIVsg`,
	"bos_input": `styles-module_bos_input_CPZsE`,
	"bos_numerical_input": `styles-module_bos_numerical_input_cw7UM styles-module_bos_input_CPZsE`,
	"bos_money_input": `styles-module_bos_money_input_vCuIM styles-module_bos_input_CPZsE`,
	"bos_money_input_with_clear": `styles-module_bos_money_input_with_clear_fVW8x styles-module_bos_input_CPZsE`,
	"input_label": `styles-module_input_label_HHSxu`,
	"required_input": `styles-module_required_input_Hex3f styles-module_bos_input_CPZsE`,
	"required": `styles-module_required_SMaCK`,
	"filter_label_input_box": `styles-module_filter_label_input_box_Nw7kQ`,
	"filter_label_header_box": `styles-module_filter_label_header_box_I7S9b styles-module_filter_label_input_box_Nw7kQ`,
	"filter_switch": `styles-module_filter_switch_vadl5`,
	"filter_selection_menu": `styles-module_filter_selection_menu_q1RYC`,
	"editable_table": `styles-module_editable_table_NZjWC`,
	"editable_table_compact": `styles-module_editable_table_compact_s5v_j styles-module_editable_table_NZjWC`,
	"table_header_cell": `styles-module_table_header_cell_VmzdZ`,
	"editable_table_edit_mode": `styles-module_editable_table_edit_mode_SYjF4`,
	"money_cell": `styles-module_money_cell_gQh_8`,
	"table_total_cell": `styles-module_table_total_cell_PFqMK`,
	"status_tag": `styles-module_status_tag_MrWSz`,
	"panel_content_box": `styles-module_panel_content_box_WbDO7`,
	"panel_content_box_vertical": `styles-module_panel_content_box_vertical_QvKJk styles-module_panel_content_box_WbDO7`,
	"panel_flex_box": `styles-module_panel_flex_box_nLgOV`,
	"half_panel": `styles-module_half_panel_H4pyA`,
	"semi_wide_panel": `styles-module_semi_wide_panel_PDRLF`,
	"wide_panel": `styles-module_wide_panel_ta9JZ`,
	"full_width_panel": `styles-module_full_width_panel_h51J9`,
	"bos_label": `styles-module_bos_label_IUS6Z`,
	"bos_sub_label": `styles-module_bos_sub_label_eXtbJ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondary_color"]}`,
	"light_border": `styles-module_light_border_WVXA4`,
	"light_border_top": `styles-module_light_border_top_r4cHN`
};
export default ___CSS_LOADER_EXPORT___;
